import { useCallback } from 'react';

import { useFormController } from '@dreryk/react-common';
import { MessageType, StyledFlex } from '@dreryk/react-components';

import { aiAssistantSettingsPanelTranslationKeys } from '../../translations';

import { useAiAssistantConfigurationToggleCommand } from './AiAssistantSettingsForm.hooks';
import { StyledDisableAiAssistantWarningMessage } from './AiAssistantSettingsForm.styled';
import { AiAssistantSettingsFormBean, AiAssistantSettingsFormInitializer } from './AiAssistantSettingsForm.types';
import { AiAssistantSettingsEnabledField } from './fields/AiAssistantSettingsEnabledField';

type AiAssistantSettingsFormProps = Readonly<{
   initializer: AiAssistantSettingsFormInitializer;
   locked: boolean;
}>;

export const AiAssistantSettingsForm = (props: AiAssistantSettingsFormProps): JSX.Element => {
   const { register, handleSubmit, watch, setValue } = useFormController<AiAssistantSettingsFormBean>(
      props.initializer(),
      { mode: 'onChange' }
   );
   const { executeAsync: enableAiAssistant, loading: aiAssistantLoading } = useAiAssistantConfigurationToggleCommand({
      onFailure: (parameters) => setValue('enabled', !parameters.enabled),
   });
   const enabled = watch('enabled');

   const toggleAiAssistant = useCallback(
      async (formBean: AiAssistantSettingsFormBean) => enableAiAssistant(formBean).catch(() => undefined),
      [enableAiAssistant]
   );

   return (
      <StyledFlex direction={'column'} gap={'16px'}>
         <form onInput={handleSubmit(toggleAiAssistant)}>
            <AiAssistantSettingsEnabledField register={register} disabled={props.locked || aiAssistantLoading} />
         </form>
         {enabled ? null : (
            <StyledDisableAiAssistantWarningMessage
               testId={'disableAiAssistantWarning'}
               type={MessageType.WARNING}
               label={aiAssistantSettingsPanelTranslationKeys.disableAiAssistantWarning}
               displayIndicator
               fullWidth
            />
         )}
      </StyledFlex>
   );
};
